export function GetMaxZIndex() {
    return Math.max(
        ...Array.from(document.querySelectorAll('body *'), el =>
            parseFloat(window.getComputedStyle(el).zIndex),
        ).filter(zIndex => !Number.isNaN(zIndex)),
        0,
    );
}

export function sortProjects(value, list, upcomingConferences) {
    if (value === "1") {
        let alphabeticalProjectsList = list.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        });
        return alphabeticalProjectsList
    } else if (value === "2") {
        let alphabeticalProjectsList = list.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) return 1;
            if (nameA > nameB) return -1;
            return 0;
        });
        return alphabeticalProjectsList
    } else if (value === "3") {
        let sortedUpcomingConf = upcomingConferences.sort((a, b) => new Date(a.scheduleDate) - new Date(b.scheduleDate));
        let projectsWithUpcomingConference = []
        let projectsWithoutUpcomingConference = []
        for (let i = 0; i < list.length; i++) {
            if (upcomingConferences.some(conference => conference.project === list[i]._id)) {
                projectsWithUpcomingConference.push(list[i])
            } else {
                projectsWithoutUpcomingConference.push(list[i])
            }
        }
        const conferenceIndexMap = new Map();
        sortedUpcomingConf.forEach((conference, index) => {
            conferenceIndexMap.set(conference.project, index);
        });
        projectsWithUpcomingConference.sort((a, b) => {
            const indexA = conferenceIndexMap.get(a._id);
            const indexB = conferenceIndexMap.get(b._id);
            return indexA - indexB;
        })
        let upcomingProjects = [...projectsWithUpcomingConference, ...projectsWithoutUpcomingConference]
        return upcomingProjects
    } else if (value === "4") {
        let sortedUpcomingConf = upcomingConferences.sort((a, b) => new Date(a.scheduleDate) - new Date(b.scheduleDate));
        let projectsWithUpcomingConference = []
        let projectsWithoutUpcomingConference = []
        for (let i = 0; i < list.length; i++) {
            if (upcomingConferences.some(conference => conference.project === list[i]._id)) {
                projectsWithUpcomingConference.push(list[i])
            } else {
                projectsWithoutUpcomingConference.push(list[i])
            }
        }
        const conferenceIndexMap = new Map();
        sortedUpcomingConf.forEach((conference, index) => {
            conferenceIndexMap.set(conference.project, index);
        });
        projectsWithUpcomingConference.sort((a, b) => {
            const indexA = conferenceIndexMap.get(a._id);
            const indexB = conferenceIndexMap.get(b._id);
            return indexB - indexA;
        })
        let upcomingProjects = [...projectsWithUpcomingConference, ...projectsWithoutUpcomingConference]
        return upcomingProjects
    } else if (value === "5") {
        let createdProjectList = list.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate))
        return createdProjectList
    } else if (value === "6") {
        let createdProjectList = list.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
        return createdProjectList
    }

}

export function formatDate(date) {
    const dayNumber = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleDateString('en-US', { month: 'long' });
    const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' });
    return { dayNumber, month, dayOfWeek };
};

export function generateDateList(currentDate, dayOffsetStart, dayOffsetEnd) {
    // const dayOffset = 17; 
    let dateList = [];

    for (let i = -dayOffsetStart; i <= dayOffsetEnd; i++) {
        const date = new Date(currentDate);
        date.setDate(currentDate.getDate() + i);
        const { dayNumber, month, dayOfWeek } = formatDate(date);
        dateList.push({ dayNumber, month, dayOfWeek, date });
    }

    return dateList;
};

export function generateHourList(nr) {
    let hourList = [];

    for (let i = 0; i < nr; i++) {
        const formattedHour = String(i).padStart(2, '0') + ':00';
        hourList.push(formattedHour);
    }

    for (let hour = 0; hour <= 23; hour++) {
        const formattedHour = String(hour).padStart(2, '0') + ':00';
        hourList.push(formattedHour);
    }

    for (let i = 0; i <= nr; i++) {
        const formattedHour = String(i).padStart(2, '0') + ':00';
        hourList.push(formattedHour);
    }

    return hourList;
};

export function newGenerateHourList() {
    let hourList = [];

    for (let hour = 0; hour <= 23; hour++) {
        const formattedHour = String(hour).padStart(2, '0') + ':00';
        hourList.push(formattedHour);
    }

    for (let i = 0; i <= 7; i++) {
        const formattedHour = String(i).padStart(2, '0') + ':00';
        hourList.push(formattedHour);
    }

    return hourList;
};

export function compareDate(date1, date2) {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
}

export function getUpcomingConferences(socketRef, userId, setNotificationUpcomingConferences) {
    if (!socketRef || !socketRef.current) {
        console.error("Socket reference is not valid.");
        return;
    }

    socketRef.current.emit("GET_UPCOMING_CONFERENCES", userId, (conferences) => {
        setNotificationUpcomingConferences(conferences);
    });
}

export function sortNotesByUpdatedAt(notesTexts) {
    const now = new Date();
    return [...notesTexts].map(note => {
        const updatedAt = note.updatedAt ? new Date(note.updatedAt) : new Date("2025-06-11T00:00:00.043Z");
        let timeCategory = null;

        if (updatedAt) {
            const diffTime = now - updatedAt;
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            if (updatedAt.toDateString() === now.toDateString()) {
                timeCategory = "Today";
            } else if (diffDays <= 7) {
                timeCategory = "Previous 7 days";
            } else if (diffDays <= 30) {
                timeCategory = "Previous 30 days";
            } else if (updatedAt.getFullYear() === now.getFullYear()) {
                timeCategory = "Earlier this year";
            } else {
                timeCategory = "A long time ago";
            }
        }

        return {
            ...note,
            timeCategory,
        };
    }).sort((a, b) => {
        const aDate = a.updatedAt ? new Date(a.updatedAt) : null;
        const bDate = b.updatedAt ? new Date(b.updatedAt) : null;

        if (aDate && bDate) return bDate - aDate;
        if (aDate) return -1;
        if (bDate) return 1;
        return 0;
    });
}

export function isTouchDevice() {
    if (typeof window === "undefined" || typeof navigator === "undefined") {
        return false;
    }

    // Modern, reliable
    if ("maxTouchPoints" in navigator && navigator.maxTouchPoints > 0) {
        // console.log("Touch device detected via maxTouchPoints:", navigator.maxTouchPoints);
        return true;
    }

    // Older Microsoft
    if ("msMaxTouchPoints" in navigator && navigator.msMaxTouchPoints > 0) {
        // console.log("Touch device detected via msMaxTouchPoints:", navigator.msMaxTouchPoints);
        return true;
    }

    // Pointer API: "coarse" usually means a finger
    if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) {
        // console.log("Touch device detected via pointer media query");
        return true;
    }

    // Very old-school fallback
    if ("ontouchstart" in window) {
        // console.log("Touch device detected via ontouchstart");
        return true;
    }

    return false;
}